import Vue from 'vue';
import staticData from 'tmp/activity-b.json';
import axios from 'axios';
import Monitor from '@/common/monitor.js'
import {filter, defaultsDeep, forEach, includes, intersectionWith, omit, keys, map, findIndex} from 'lodash';
import {getLocationSearch, getCookie, uuid, getPlatform, setCookie} from '@/common/util';
import {
    getAllProvinceCity,
    getDealerList,
    getArticleList,
    getSeriesInfo,
    getPositionInfo,
    getSpecPrice,
    getAllPrice,
    getUserInfo,
    submitLeads
} from './api';
import { isAutohomeApp } from '../../../../common/util';
// PC: 1,  M: 2, APP: 3
const deviceMap = {
    1: 'pc',
    2: 'm',
    3: 'app'
};
export default new Vue({
    created() {
        this.init();
    },
    data() {
        const sessionId = getCookie('sessionid');
        return {
            data: staticData,
            provinceCityInfo: [],
            dealerInfo: {
                dealerList: []
            },
            dealerInfoMsg: '',
            price: {
                normal: {},
                lower: {}
            },
            form: {
                series: {
                    id: '',
                    name: ''
                },
                spec: {
                    id: '',
                    name: ''
                },
                position: {
                    ...staticData.position
                },
                dealers: [],
                mobile: '',
                name: ''
            },
            env: {
                visitId: uuid(),
                device: deviceMap[getPlatform()],
                ip: getCookie('sessionip') || '',
                sessionId: sessionId ? sessionId.split('||')[0] : '',
                source: 2,
                pageType: 3,
                time: Date.now()
            },
            locationSearch: getLocationSearch(),
            locationSearchExtra: omit(this.locationSearch, ['channelId', 'pageId', 'eid', 'site', 'testIdInuse', 'testId', 'pvid', 'adPosId', 'seriesId', 'taskId', 'spec', 'specId']),
            loading: {
                count: 0,
                show: false,
                text: ''
            }
        };
    },
    computed: {
        head() {
            return this.data.head;
        },
        carSeries() {
            return this.data.carSeries;
        },
        specification() {
            return this.data.carSeries.specification;
        },
        seriesList() {
            return this.data.carSeries.series.list;
        },
        specList() {
            const spec = filter(this.specification.list, item => item.seriesId === this.form.series.id)[0]; 
            if (spec && spec.specList) {
                return spec.specList;
            }
            return [];
        },
        promotion() {
            return this.data.promotion;
        },
        autoshow() {
            return this.data.autoshow
        },
        information() {
          return this.data.information
        }
    },
    methods: {
        getClickMonitorParams() {
            const {channelId = '', pageId = '', eid = '', site = '', testId = '', pvid = '', adPosId = ''} = this.locationSearch;
            const {source, pageType, sessionId, ip, visitId, time, device} = this.env;
            const params = {
                source,
                pageType,
                pvAreaId: eid,
                sessionId,
                u: window.location.href,
                cityId:  this.form.position.cityId,
                seriesId: this.form.series.id,
                specId: this.form.spec.id,
                ip,
                visitId: visitId,
                adposId: adPosId,
                site,
                pvId: pvid,
                pageId,
                channelId,
                testId: testId,
                device,
                costTime: Date.now() - time
            };
            return {
                ...params,
                ...omit(this.locationSearchExtra, keys(params))
            };
        },
        getPVMonitorParams() {
            const {channelId = '', pageId = '', eid = '', site = '', testId = '', pvid = '', adPosId = ''} = this.locationSearch;
            const {source, pageType, sessionId, ip, visitId, time, device} = this.env;
            const params = {
                source,
                pageType,
                pvAreaId: eid,
                sessionId,
                cityId: this.form.position.cityId,
                seriesId: this.form.series.id,
                specId: this.form.spec.id,
                ip,
                visitId: visitId,
                pageId,
                channelId,
                adposId: adPosId,
                site,
                device,
                pvId: pvid,
                testId: testId,
                costTime: Date.now() - time
            };
            return {
                ...params,
                ...omit(this.locationSearchExtra, keys(params))
            };
        },
        async init() {
            // 清掉之前设置在子域名下的cookie
            setCookie('cookieCityId', '', 0.5, 'leads.yz.test.autohome.com.cn');
            setCookie('cookieCityId', '', 0.5, 'leads.autohome.com.cn');

            this.initSeries();
            this.initSpec();
            await this.initPosition();
            this.getUserInfo();
            this.reportpv();
        },
       
        initSeries() {
            this.updateSeriesOrder();
            this.form.series.id = this.seriesList[0].id;
            this.form.series.name = this.seriesList[0].name;
        },
        specInSpecList(id = '') {
            const spec = filter(this.specList, spec => spec.specId.toString() === id.toString())[0];
            if (spec) {
                return spec;
            }
            return null;
        },
        initSpec() {
            let spec = this.specInSpecList(this.locationSearch.specId) || this.specList[0];
            if (spec) {
                this.form.spec.id = spec.specId;
                this.form.spec.name = spec.specName;
            }
        },
        updateSeriesOrder() {
            // 将当前seriesId对应的车系放在seriesList第一位
            if (this.locationSearch.seriesId) {
                this.data.carSeries.series.list.sort((a, b) => {
                    if (a.id === this.locationSearch.seriesId) {
                        return -1;
                    }
                    return 0;
                });
            }
        },
        async initPosition() {
            let position = this.data.position;
            // 设置定位信息
            // 1、首先通过url取 
            let {cityId = ''} = this.locationSearch;
            let cityName = '';
            // 2、 取cookie cookieCityId
            if( !cityId) {
                cityId = getCookie('cookieCityId');
            }
            //3、 通过ip获取 
            const res = await this.getPosition();
            position = res || {};
           
            // 获取城市列表
            try {
                this.provinceCityInfo = await this.getAllProvince();
            } catch {
                console.log('出错了');
            }
            let positionTemp = this.findPosition(this.provinceCityInfo, cityId);
            if (!cityId || cityId == position.cityId || !positionTemp.cityId) {
                // 取ip定位的城市
                this.form.position = position;
            } else {
                // 通过cityId查出来的
                this.form.position = positionTemp;
            }
            console.log('this.form.position:', this.form.position);
            this.$eventBus.$emit('allCityData', this.provinceCityInfo);
        },
        reportpv() {
             // pv上报
             Monitor.send('//leads.api.autohome.com.cn/monitor/deliver', this.getPVMonitorParams());
        },
        async getAllProvince() {
            return await getAllProvinceCity().then(res => {
                if (res.status === 1 && res.data) {
                    return res.data;
                }
            });
        },
        findPosition(arr, id) {
            for(let i=0; i<arr.length; i++) {
                let item = arr[i].area;
                let itemFlag = arr[i].flag;
                for(let j=0; j<item.length; j++) {
                    let cityList = item[j].cityList;
                    for(let k=0; k< cityList.length; k++) {
                        let curCity = cityList[k];
                        if(id == curCity.cityId) {
                            return {
                                ...curCity,
                                provinceId: item[j].provinceId,
                                provinceName: item[j].provinceName,
                                provinceName: itemFlag
                            }
                        }
                    }
                }
            }
            return {};
        },
        async updateDealerList() {
            const {series, spec} = this.form;
            const {cityId} = this.form.position;
            if(series.id && spec.id && cityId) {
                const dealerInfo = await this.getDealer(series.id, spec.id, cityId);
                if(dealerInfo.dealerList) {
                    dealerInfo.dealerList = this.unique(dealerInfo.dealerList);
                }
                this.dealerInfo = dealerInfo;
                // 方便查看线上获取到的经销商
                window.dealerInfo = this.dealerInfo;
                if( this.dealerInfo.dealerList && this.dealerInfo.dealerList.length){
                    // this.updateDealer();
                    this.form.dealers = this.dealerInfo.dealerList.slice(0,3);
                    console.log('this.form.dealers:',this.form.dealers)
                    this.dealerInfoMsg = "";
                } else {
                    this.form.dealers = [];
                    this.dealerInfoMsg = "抱歉，当前城市无可选经销商，请您切换城市进行咨询";
                }
            }
            
        },
        async updateArticleList() {
            const {cityId} = this.form.position;
            if(!cityId){
                return;
            }
            let list = [];
            try {
                const res = await getArticleList(cityId);
                list = res.data.result;
                this.information.list = list;
            } catch {
               
            }
            
            // 方便查看线上获取到的文章
            window.articleList = this.information.list;
        },
        // updateDealer() {
        //     let {dealerList} = this.dealerInfo;
        //     let dealerNum = 3;
        //     const length = dealerList.length;
        //     if(length >= 3) {
        //         dealerNum = 3;
        //     }else {
        //         dealerNum = length;
        //     }
            
        //     const dealersIndex = [];
        //     while (dealerNum) {
        //         const index = Math.floor(Math.random() * length);
        //         if (!includes(dealersIndex, index)) {
        //             dealersIndex.push(index);
        //             dealerNum--;
        //         }
        //     }
        //     this.form.dealers = map(dealersIndex, index => dealerList[index]);
        //     forEach(this.form.dealers, item => {
        //         let index = findIndex(dealerList, item);
        //         dealerList.splice(index, 1);
        //         dealerList.unshift(item);
        //     })
        //     window.dealers = this.form.dealers;
        // },
        // 去重
        unique(arr){
            let json = {};
            let newArr = [];
            for(var i=0; i<arr.length; i++) {
                let id = arr[i].id;
                if(!json[id]) {
                    json[id] = arr[i];
                    newArr.push(arr[i]);
                }
            }
            return newArr;
        },
        async updatePrice() {
            const {series, spec} = this.form;
            const {cityId} = this.form.position;
            if(!cityId){
                return;
            }
            const data = await this.getPrice(series.id, spec.id, cityId);
            this.price.normal = data[0];
            this.price.lower = data[1];
        },
        async getDealer(seriesId, specId, cityId) {
            if (seriesId && specId && cityId) {
                return await getDealerList(seriesId, specId, cityId).then(res => {
                    if (res.status === 1 && res.data) {
                        return res.data;
                    }
                });
            }
            return {};
        },
        getSeries(seriesId) {
            getSeriesInfo(seriesId).then(res => {
                if (res.status === 1 && res.data) {
                    // console.log(res);
                }
            });
        },
        async getPosition() {
            return await getPositionInfo().then(res => {
                if (res.status === 1 && res.data) {
                    return res.data;
                }
                return {};
            });
        },
        async getPrice(seriesId, specId, cityId) {
            if (!seriesId || !specId || !cityId) {
                return {};
            }
            return await axios.all([
                getSpecPrice(seriesId, specId, cityId).then(res => {
                    if (res.status === 1 && res.data) {
                        return res.data;
                    }
                    return {};
                }),
                getAllPrice(specId, cityId).then(res => {
                    if (res.status === 1 && res.data) {
                        return res.data;
                    }
                    return {};
                })
            ]);
        },
        async getUserInfo() {
            let name = getCookie('userName');
            let mobile = getCookie('telphone');
            if (!(/^1\d{10}$/.test(mobile))) {
                const data = await getUserInfo()
                mobile = data.mobilePhone;
                if (!name) {
                    name = data.realName || data.nickName;
                }
            }
            if (name) {
                this.form.name = name;
            }
            if (/^1\d{10}$/.test(mobile)) {
                this.form.mobile = mobile;
            }
        },
        async submit() {
            const {channelId = '', pageId = '', eid = '', site = '', testId = '', pvid = '', adPosId = '', taskId = ''} = this.locationSearch;
            const params = {
                u: window.location.href,
                sessionId: this.env.sessionId,
                visitid: this.env.visitId,
                device: this.env.device,
                testid: testId,
                pageurlid: pageId,
                adposId: adPosId,
                pvareaid: eid,
                slchanid: channelId,
                pvId: pvid,
                site: site,
                slname: this.form.name.trim(),
                slmobile: this.form.mobile,
                slcity: this.form.position.cityId,
                slprovince: this.form.position.provinceId,
                slcarseries: this.form.series.id,
                slcarspec: this.form.spec.id,
                sldealer: map(this.form.dealers, dealer => {
                    if(dealer.id == 0){
                        return dealer.id + '_' + dealer.deliverId;
                    } else {
                        return dealer.id;
                    }
                    
                }).join(','),
                // dealername: this.form.dealer.name,
                // taskid: taskId || '',
                // taskid: this.form.series.taskid,
                taskid: 630686,
                ...this.locationSearchExtra
            };
            return await submitLeads({...params, ...omit(this.locationSearchExtra)}).then(res => {
                if (res.status === 0) {
                    return {status: true, pvid: res.pvid};
                }
                return {status: false, msg: res.statusInfo.msg};
            });
        },
        changeLoadingState(showLoading, text) {
            if (showLoading) {
                this.loading.count++;
                this.loading.show = showLoading;
                this.loading.text = text ? text : this.loading.text;
                return;
            }
            if (this.loading.count === 0) {
                this.loading.show = false;
                return;
            }
            this.loading.count--;
            this.loading.show = !!this.loading.count;
        }
    },
    watch: {
        'dealerInfoMsg': function(newVal) {
            console.log('dealerMsg更新了',newVal);
        },
        'form.series.id': {
            handler: function () {
                if (!this.specList || !this.specList.length) {
                    return;
                }
                if (this.specInSpecList(this.form.spec.id)) {
                    return;
                }
                this.form.spec.id = this.specList[0].specId;
                this.form.spec.name = this.specList[0].specName;
            }
        },
        'form.spec.id': function () {
            this.updateDealerList();
            this.updatePrice();
        },
        'form.position.cityName': function(newVal, oldVal){
            // if (newVal) {
            //     setCookie('cityName', newVal, 365 * 24 * 60 * 60 * 1000);
            // }
        },
        'form.position.cityId': {
            handler: function(newVal, oldVal) {
                console.log('cityId更新了');
                if (!newVal || newVal == oldVal) {
                    return;
                }
                this.updateDealerList();
                this.updatePrice();
                this.updateArticleList();
                if (newVal && this.env.device !== 'app') {
                    setCookie('cookieCityId', newVal, 365 * 24 * 60 * 60 * 1000, 'autohome.com.cn');
                }
            },
            immediate: true
        },
        'provinceCityInfo': function(newVal, oldVal) {
            this.$eventBus.$emit('allCityData', this.provinceCityInfo);
        },
        'form.mobile': function () {
            if (/^1\d{10}$/.test(this.form.mobile)) {
                setCookie('telphone', this.form.mobile, 365 * 24 * 60 * 60 * 1000);
            }
        },
        'form.name': function () {
            if (this.form.name.trim()) {
                setCookie('userName', this.form.name, 365 * 24 * 60 * 60 * 1000);
            }
        },
        'locationSearch.seriesId': {
            immediate: true,
            handler() {
                this.updateSeriesOrder();
            }
        }
    }
});
